<svg width="24" height="24" viewBox="0 0 24 24" fill="#111" xmlns="http://www.w3.org/2000/svg">
  <circle cx="9.23092" cy="9.23092" r="1.84615"/>
  <circle cx="14.769" cy="9.23092" r="1.84615"/>
  <circle cx="14.769" cy="14.768" r="1.84615"/>
  <circle cx="9.23092" cy="14.768" r="1.84615"/>
  <circle cx="4.30792" cy="14.7698" r="1.23077"/>
  <circle cx="4.30792" cy="9.23077" r="1.23077"/>
  <circle cx="4.30792" cy="4.30694" r="1.23077"/>
  <circle cx="19.6927" cy="4.30889" r="1.23077"/>
  <circle cx="19.6927" cy="19.6917" r="1.23077"/>
  <circle cx="4.30792" cy="19.6917" r="1.23077"/>
  <circle cx="9.23077" cy="4.30694" r="1.23077"/>
  <circle cx="14.7689" cy="4.30889" r="1.23077"/>
  <circle cx="19.6927" cy="9.23077" r="1.23077"/>
  <circle cx="19.6927" cy="14.7698" r="1.23077"/>
  <circle cx="14.7689" cy="19.6917" r="1.23077"/>
  <circle cx="9.23077" cy="19.6917" r="1.23077"/>
  <circle cx="9.23062" cy="23.3849" r="0.615385"/>
  <circle cx="14.7697" cy="23.3849" r="0.615385"/>
  <circle cx="23.3849" cy="14.7697" r="0.615385"/>
  <circle cx="23.3849" cy="9.23062" r="0.615385"/>
  <circle cx="14.7697" cy="0.615385" r="0.615385"/>
  <circle cx="9.23062" cy="0.615385" r="0.615385"/>
  <circle cx="0.615385" cy="9.23062" r="0.615385"/>
  <circle cx="0.615385" cy="14.7697" r="0.615385"/>
</svg>